import { isProdEnvironment } from '../../interfaces/environment/Environment';
import { getWindow } from '../../services/windowService';
import { AppAction, AppActions } from './appActions';
import { AppState } from './AppContext';

const wnd = getWindow();

const emptyUser = {
  loggedIn: false,
  username: null,
  userId: null,
  roles: null,
};

export const appReducer = (currentState: AppState, action: AppAction) => {
  let state = currentState;
  switch (action.type) {
    case AppActions.USER_LOGGED_IN:
      const { username, userId, roles } = action.payload;
      state = { ...state, username, userId, roles, loggedIn: true };
      break;
    case AppActions.USER_LOGGED_OUT:
      state = { ...state, ...emptyUser };
      break;
    case AppActions.SET_USERNAME:
      state = { ...state, username: action.payload };
      break;
    case AppActions.SET_COMPONENT_VISIBILITY:
      const [name, visibility] = action.payload;
      const alreadyVisible = state.visibleComponents.indexOf(name) >= 0;
      if (visibility !== alreadyVisible) {
        const visibleComponents = visibility
          ? [...state.visibleComponents, name]
          : state.visibleComponents.filter((item) => item !== name);
        state = {
          ...state,
          visibleComponents,
        };
      }
      break;
    default:
      console.error(`Action ${(action as any).type} is not implemented.`);
      break;
  }
  if (!isProdEnvironment()) {
    (wnd as any).appState = state;
  }
  return state;
};
